import { makeAsyncActionCreators } from '../../helpers';
import { PromptsActionTypes } from '../types';

const getPrompts = makeAsyncActionCreators(
  PromptsActionTypes.getPrompts,
  ['types'],
  ['prompts'],
  ['error'],
);

const savePrompt = makeAsyncActionCreators(
  PromptsActionTypes.savePrompt,
  ['prompt'],
  ['prompt'],
  ['error'],
);

export default {
  getPrompts,
  savePrompt,
};
